
































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import * as XLSX from 'xlsx';
import GLoading from '@/components/GLoading.vue';
import { importModalModule } from '@/store/modules/frames/import-modal.module';

@Component({
  name: 'GImportModal',
  components: { GLoading },
  computed: {},
  methods: {},
})
export default class GImportModal extends mixins(GPageBase) {
  showImportModal: boolean = false; // インポート用モーダル表示フラグ
  tmpFile: File = {} as File; // D&Dしたファイル
  showConfirmModal_: boolean = false; // 確認画面用モーダル表示フラグ
  formData: FormData = new FormData(); // ファイル送信用データフォーム
  isRunning: boolean = false; // ファイル読み込み状態

  @Prop() value: boolean;
  @Prop() title: string;
  @Prop() showConfirmModal: boolean;
  @Prop() registerButtonDisabled: boolean;
  @Prop() isCheckDifference: boolean;
  @Prop() dispString: string;

  @Watch('value')
  openModal(value: boolean) {
    this.showImportModal = value;
  }

  @Watch('showConfirmModal')
  watchShowConfirmModal() {
    this.showConfirmModal_ = this.showConfirmModal;
  }

  @Watch('showConfirmModal_')
  watchShowConfirmModal_(value: boolean) {
    this.$emit('update', value);
  }

  mounted() {}

  handleTemplateDownload(): void {
    importModalModule.setIsDownloading(true);
    this.$emit('handleTemplateDownload');
  }

  handleBeforeUpload(file: File) {
    this.tmpFile = file;
  }

  handleProgress(): void {
    this.isRunning = true;
    var loadFile = (file: File) => {
      return new Promise<ArrayBuffer>((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      });
    };
    loadFile(this.tmpFile).then((data: ArrayBuffer) => {
      this.isRunning = false;
      const wb: XLSX.WorkBook = XLSX.read(data, { type: 'buffer' });
      this.$emit('handleUpload', wb);
      // 差分確認実施の場合
      if (this.isCheckDifference) {
        importModalModule.setIsCheckDifferenceRunning(true);
        this.formData = new FormData();
        this.formData.append('file', this.tmpFile);
        this.$emit('handleCheckDifference', this.formData, this.tmpFile.name || '');
      }
    });
  }

  handleFormatError(): void {
    this.showNotice(GEnum.MessageType.Warn, this.$t('ERROR_UPDATE').toString(), this.$t('ERROR_REQUIRE_FILE_EXCEL').toString(), 10);
  }

  handleClose() {
    this.$emit('input', false);
  }

  handleCancel() {
    this.showConfirmModal_ = false;
    this.formData = new FormData();
    this.$emit('confirmModalCanceled');
  }

  handleOK() {
    importModalModule.setIsUploading(true);
    this.formData = new FormData();
    this.formData.append('file', this.tmpFile);
    this.$emit('handleOK', this.formData);
  }

  get isDownloading(): boolean {
    return importModalModule.isDownloading;
  }

  get isCheckDifferenceRunning(): boolean {
    return importModalModule.isCheckDifferenceRunning;
  }

  get isUploading(): boolean {
    return importModalModule.isUploading;
  }

  get confirmModalWidth(): number {
    if (this.isCheckDifference) return 1200;
    return 500;
  }
}
